import React, { useContext, useEffect, useState } from "react";
import { isLogin } from "../../utils/constant";
import { useLocation } from "react-router-dom";
import { AppContext } from "../../utils/AppProvider";

// Utility to check license status
const checkLicenseStatus = (dateStr) => {
  
  if (!dateStr) return "missing";

  const expiry = new Date(dateStr);
  const today = new Date();
  const diffDays = (expiry - today) / (1000 * 60 * 60 * 24);

  if (diffDays < 0) return "expired"; // Expired
  if (diffDays <= 15) return "expiring"; // Expiring soon
  return "valid";
};

const SlimMessageModule = ({toggleValue}) => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");

  const location = useLocation();
  const { tob_expiry } = useContext(AppContext);



  useEffect(() => {
    if (!isLogin()) return;

    const dismissedAt = localStorage.getItem("certi_banner_dismissed_at");
    if (dismissedAt) {
      const diff = (new Date() - new Date(dismissedAt)) / (1000 * 60 * 60 * 24);
      if (diff < 1) return;
    }

    const tobStatus = checkLicenseStatus(tob_expiry);


    let msg = "";
    const emailLink = `<a href="mailto:info@n2nsolution.co" class="alert-link">info@n2nsolution.co</a>`;

    if (tobStatus === "missing") {
      msg = `Your business license is currently not on file, please email us a copy of your updated state business license at ${emailLink}.`;
    } else if (tobStatus === "expired") {
      msg = `Your business license has expired. Please email us a copy of your updated state business license at ${emailLink}.`;
    } else if (tobStatus === "expiring") {
      msg = `Your business license is expiring soon. Please email us a copy of your updated state business license at ${emailLink}.`;
    }

    if (msg) {
      setMessage(msg);
      setShow(true);
    }
  }, [location.pathname, tob_expiry,toggleValue]);



  useEffect(() => {
    if (show) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return () => document.body.classList.remove("modal-open");
  }, [show]);

  const handleClose = () => {
    localStorage.setItem("certi_banner_dismissed_at", new Date().toISOString());
    setShow(false);
  };

  if (!show) return null;

  return (
    <>
      {/* {isLogin() ? (
        <div
          className="alert alert-danger alert-dismissible fade show py-2 px-3 text-center mb-0 position-relative d-flex justify-content-center align-items-center small"
          role="alert"
        >
          <div
            className="flex-grow-1"
            dangerouslySetInnerHTML={{ __html: message }}
          />
          <button
            type="button"
            className="btn-close position-absolute top-50 end-0 translate-middle-y me-3"
            onClick={handleClose}
            aria-label="Close"
          />
        </div>
      ) : null} */}
      {isLogin() && (
        <div
          className={`modal fade ${show ? "show d-block" : ""}`}
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content custom-modal-rounded">
              <div
                className="modal-header text-white"
                // style={{ backgroundColor: "#e57d26" }}
              >
                <h5 className="modal-title">License Alert</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}
                  aria-label="Close"
                />
              </div>
              <div className="modal-body ">
                <div dangerouslySetInnerHTML={{ __html: message }} />
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary" onClick={handleClose}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SlimMessageModule;
